import { render, staticRenderFns } from "./instantExchange.vue?vue&type=template&id=5489c668&scoped=true"
import script from "./instantExchange.vue?vue&type=script&lang=js"
export * from "./instantExchange.vue?vue&type=script&lang=js"
import style0 from "./instantExchange.vue?vue&type=style&index=0&id=5489c668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489c668",
  null
  
)

export default component.exports